import { Grid } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { AppContext } from '../../../../app-context';
import IForm from '../../../../components/i-form/i-form.component';
import ITextField from '../../../../components/text-component/textfield/i-textfield.component';
import { formatDate, isEmpty, isNotNull } from '../../../common/util.services';
import { getScheduleById, saveSchedule, getWorkFlow } from '../../production.services';
import { getOrderById } from '../../../order/order.services';
import './schedule-form.component.scss';
import IDateField from '../../../../components/text-component/i-datefield/i-datefield.component';
import dayjs from 'dayjs';
import WorkflowComponent from '../../workflow/workflow.component';
import { GridRowsProp, useGridApiRef } from '@mui/x-data-grid';
import IReadOnlyField from '../../../../components/text-component/readonly-field/i-readonlyfield.component';

const ScheduleForm = (props: any) => {
  const [title, setTitle] = useState<string>('');
  const appContext = useContext(AppContext);
  const navigate = useNavigate();
  const params = useParams()
  const rows: GridRowsProp = [];
  const apiRef = useGridApiRef();
  const [workflow, setWorkflow] = useState(rows);
  const rowId = params.rowId;
  const [scheduleData, setScheduleData] = useState<any>({});
  const [loader, setLoader] = useState(true);
  const {state} = useLocation();
  const {orderId, product} = state;
  const [startDate, setStartDate] = useState(formatDate(dayjs()));
  const [endDate, setEndDate] = useState(formatDate(dayjs()));
  const [tat, setTAT] = useState(0);
  const [daysLeft, setDaysLeft] = useState(0);
  const [ageing, setAgeing] = useState(0);
  const [qltyStatus, setQltyStatus] = useState('Pending');

  useEffect(() => {
    if (isNotNull(rowId)) {
      getScheduleById(rowId, appContext,
        (response: any) => {
          setTitle('Edit Schedule');
          response.data.pack = 0 === response.data.pack ? 'NA' : response.data.pack;
          response.data.orderDate = dayjs(response.data.orderDate);
          response.data.targetDate = dayjs(response.data.targetDate);
          setScheduleData(response.data);
          setWorkflow(response.data.workflow);
          setStartDate(formatDate(response.data.startDate));
          setEndDate(formatDate(response.data.endDate));
          setTAT(response.data.tat);
          setDaysLeft(response.data.daysLeft);
          setAgeing(response.data.ageing);
          setQltyStatus(response.data.qltyStatus);
          setLoader(false);
          appContext.setShowLoader(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          setLoader(false);
        });
    } else {
      setTitle('Add Schedule');
      getOrderById(orderId, appContext,
        (response: any) => {
          scheduleData.orderId = response.data.rowId;
          scheduleData.status = 'New';
          scheduleData.orderCode = response.data.code;
          scheduleData.enquiryCode = response.data.enquiryCode;
          scheduleData.customer = response.data.customer;
          scheduleData.orderType = response.data.type;
          scheduleData.orderPriority = response.data.priority;
          scheduleData.product = product.product;
          scheduleData.quantity = product.quantity;
          scheduleData.uom = product.uom;
          scheduleData.pack = 0 === product.pack ? 'NA' : product.pack;
          scheduleData.remarks = product.orderRemarks;
          scheduleData.enqPrdId = product.enqProductId;
          scheduleData.costingId = product.costingId;
          scheduleData.orderDate = dayjs(response.data.orderDate);
          scheduleData.targetDate = dayjs(product.targetDate);
          appContext.setShowLoader(false);
          setLoader(false);
          appContext.setShowLoader(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          setLoader(false);
        });

      getWorkFlow(product.costingId, appContext,
        (response: any) => {
          setWorkflow(response.data);
          scheduleData.workflow = response.data;
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          setLoader(false);
        });
    }
  }, []);

  const isValidWorkflow = () => {
    let valid = true;

    if(workflow.length <= 0) {
      appContext.setDialogMessage('Add workflow.');
      return false;
    }

    workflow.forEach(row => {
      if (isEmpty(row.dependency) || isEmpty(row.status) || isEmpty(row.owner)) {
        valid = false;
        appContext.setDialogMessage('Specify Dependency, Status, and Owner.');
      }

      if('Completed' === row.status && 'Approved' !== row.qltyStatus) {
        valid = false;
        appContext.setDialogMessage('Status marked completed for pending/rejected quality status.');
      }

      if(row.plannedTAT <= 0) {
        valid = false;
        appContext.setDialogMessage('TAT should be grater than 0.');
      }

      if(!checkDates(row)) {
        valid = false;
        appContext.setDialogMessage('Incorrect start dates for dependencies.');
      }

      if(dayjs(dayjs(row.plannedStartDate).format('YYYY-MM-DD')).isBefore(dayjs(dayjs(scheduleData.orderDate).format('YYYY-MM-DD')))) {
        valid = false;
        appContext.setDialogMessage('Start date is before order date.');
      }
    })

    return valid;
  }

  const processRowUpdate = () => {
    let sDate = dayjs(workflow[0].plannedStartDate);
		let eDate = dayjs(workflow[0].plannedEndDate);
		let qStatus = 'Approved';

    workflow.forEach(row => {
      let date = dayjs(row.plannedStartDate);
      if(date.isBefore(sDate, 'date')) {
				sDate = date;
			}
			
      date = dayjs(row.plannedEndDate);
			if(date.isAfter(eDate, 'date')) {
				eDate = date;
			}
			
			if('Rejected' !== qStatus) {
				if('Rejected' === row.qltyStatus) {
					qStatus = 'Rejected';
				} else if('Pending' === row.qltyStatus) {
					qStatus = 'Pending';
				}
			}
    })

    setQltyStatus(qStatus);
    setStartDate(sDate.format('DD-MMM-YY'));
    setEndDate(eDate.format('DD-MMM-YY'));
    setTAT(eDate.diff(sDate, 'day') + 1);
    setDaysLeft(eDate.diff(dayjs(), 'day'));
    let ageing = dayjs().diff(sDate, 'day');
    setAgeing(0 < ageing ? ageing : 0);
  }

  const checkDates = (row: any) => {
    let array: any = row.dependency.split(',');
    let startDate = dayjs(row.plannedStartDate);

    for(let j = 0; j < array.length; ++j) {
      if('NA' === array[j]) {
        return true;
      } else {
        let endDate = dayjs(workflow[array[j] - 1].plannedEndDate);
        if(startDate.isBefore(endDate,'date') || startDate.isSame(endDate, 'date')) {
          return false;
        }
      }
    }

    return true;
  }

  const onSubmit = (data: any) => {
    if (isValidWorkflow()) {
      data.workflow = workflow;
      data.pack = 'NA' === data.pack ? 0 : data.pack;
      saveSchedule(data, appContext,
        (response: any) => {
          navigate(-1);
          appContext.setSuccessMessage(response.message)
          appContext.setShowLoader(false);
        }, (error: any) => {
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message)
        });
    }
  }

  const onRowSelection = (selectedRows: any) => {
    setWorkflow(selectedRows);
  }

  const onRowDelete = (selectedRows: any) => {
    setWorkflow(selectedRows);
  }

  const getMainComponent = () => {
    return <Grid container spacing={1}>
      <Grid xs={2}>
        <ITextField name='orderCode' label='Order Code' required={true} disabled={true} />
      </Grid>
      <Grid xs={2}>
        <ITextField name='enquiryCode' label='Enquiry Code' required={true} disabled={true} />
      </Grid>
      <Grid xs={2}>
        <ITextField name='customer' label='Customer' required={true} disabled={true}/>
      </Grid>
      <Grid xs={2}>
        <ITextField name='orderType' label='Order Type' required={true} disabled={true}/>
      </Grid>
      <Grid xs={2}>
        <ITextField name='orderPriority' label='Order Priority' required={true} disabled={true}/>
      </Grid>
      <Grid xs={2}>
        <ITextField name='product' label='Product' required={true} disabled={true}/>
      </Grid>
      <Grid xs={2}>
        <ITextField name='quantity' label='Quantity' required={true} disabled={true}/>
      </Grid>
      <Grid xs={2}>
        <ITextField name='uom' label='UOM' required={true} disabled={true}/>
      </Grid>
      <Grid xs={2}>
        <ITextField name='pack' label='Pc/Pack' required={true} disabled={true}/>
      </Grid>
      <Grid xs={2}>
        <IDateField name='orderDate' label='Order Date' required={true} disabled={true}/>
      </Grid>
      <Grid xs={2}>
        <IDateField name='targetDate' label='Target Date' required={true} disabled={true}/>
      </Grid>
      <Grid xs={2}>
        <ITextField name='remarks' label='Remarks' required={false}/>
      </Grid>
      <Grid xs={12}>
        <WorkflowComponent onRowSelection={onRowSelection} apiRef={apiRef} orderId={scheduleData.orderId} costingId={scheduleData.costingId}
         processRowUpdate={processRowUpdate} workflow={scheduleData.workflow} onRowDelete={onRowDelete}/>
      </Grid>
      <Grid xs={2}>
        <IReadOnlyField value={startDate} label={'Start Date'} />
      </Grid>
      <Grid xs={2}>
        <IReadOnlyField value={endDate} label={'End Date'} />
      </Grid>
      <Grid xs={2}>
        <IReadOnlyField value={tat} label={'TAT'} />
      </Grid>
      <Grid xs={2}>
        <IReadOnlyField value={daysLeft} label={'Days Left'} />
      </Grid>
      <Grid xs={2}>
        <IReadOnlyField value={ageing} label={'Ageing'} />
      </Grid>
      <Grid xs={2}>
        <IReadOnlyField value={qltyStatus} label={'Qlty Status'} />
      </Grid>
    </Grid>
  }

  return loader ? <></> : <IForm formData={scheduleData} title={title} submitForm={onSubmit} mainComponent={getMainComponent()}></IForm>
}

export default ScheduleForm;